const showEarnings: PerformanceChartType = 'showEarnings';
const sourceEarnings: PerformanceChartType = 'sourceEarnings';
const sourcePlays: PerformanceChartType = 'sourcePlays';

export const chartTypes = {
    showEarnings,
    sourceEarnings,
    sourcePlays,
};

export const defaultFilterOrder = ['broadcast', 'digital'];
export const maxSize = 10;
export const minValue = 0.01;
export const selectionIdPrefix = 'workDetail';
